import React from 'react';
import styled from 'styled-components';
import Spinner from './Spinner';
// import { P } from './Typography';

const Wrapper = styled.section`
  height: calc(100vh - 65px + 65px * 2);
  background-color: #f4f7f9;
`;

const Section = styled.section<{ isWithHeader?: boolean }>`
  /* height: calc(100vh -); */
  padding: 5rem calc((100vw - 800px) / 2);
  overflow-y: none;
  background-color: #f4f7f9;
  position: relative;
  @media (max-width: 900px) {
    height: calc(100vh - 5rem + 5rem * 2);
    padding: ${(props) =>
      props.isWithHeader ? `5rem var(--space-2)` : `3rem var(--space-2) `};
  }
`;
const Header = styled.header<{ bgColor?: string }>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 8rem;
  height: 65px;
  background-color: ${(props) =>
    props.bgColor ? `${props.bgColor}` : `#13273F`};
  @media (max-width: 900px) {
    padding: 0;
    justify-content: center;
  }
`;

const LogoWrapper = styled.div<{ bgColor?: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  position: absolute;
  border: ${(props) =>
    props.bgColor ? `5px solid ${props.bgColor}` : `5px solid #13273F`};
  top: 10px;
  border-radius: 50%;
  width: 85px;
  height: 85px;
  z-index: 99;
`;

const Logo = styled.img`
  width: 101%;
  border-radius: 50%;
`;

/* const Banner = styled.div`
  padding: var(--space-2);
  background: linear-gradient(
    270deg,
    #7914c9 12.33%,
    #af14c9 99.99%,
    #af14c9 100%
  );
  display: flex;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
`; */

/* const BannerText = styled(P)`
  color: white;
`; */

const Layout: React.FunctionComponent<any> = ({
  children /* , isSandbox */,
  customisationSettings,
}) => (
  <Wrapper>
    {customisationSettings?.headerBgColor && customisationSettings?.headerLogo && (
      <Header bgColor={customisationSettings.headerBgColor}>
        <LogoWrapper bgColor={customisationSettings.headerBgColor}>
          {customisationSettings.headerLogo ? (
            <Logo src={customisationSettings.headerLogo} alt="logo" />
          ) : (
            <Spinner />
          )}
        </LogoWrapper>
      </Header>
    )}

    <Section
      isWithHeader={
        customisationSettings?.headerBgColor &&
        customisationSettings?.headerLogo
      }
    >
      {/* isSandbox && (
      <Banner>
        <BannerText>You are in sandbox mode!</BannerText>
      </Banner>
    ) */}
      {children}
    </Section>
  </Wrapper>
);

export default Layout;
